export enum NodeEnv {
  Production = 'production',
  Development = 'development',
}

